/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 *
 */

import {
  isUndefined,
  isStr,
  isFn,
  getWindow
} from '../util';

import {
  isAndroid,
  compareAppVersion
} from '../global-api/app';

let theWindow = getWindow();
let __uid = 0;
let callbacks = {};

function initPrompt() {
  // 因为安卓源码里写死了,这里的hack我很不喜欢
  if (!isUndefined(theWindow.didi) && !isUndefined(theWindow.didi.bridge)) {
    theWindow.didi.bridge._callback = promptCallback;
  } else {
    if (isUndefined(theWindow.didi)) {
      theWindow.didi = {};
    }
    theWindow.didi.bridge = {};
    theWindow.didi.bridge._callback = promptCallback;
  }
}

function promptCallback(obj) {
  // 兼容obj是字符串的情况
  if (isStr(obj)) {
    obj = JSON.parse(obj);
  }
  let {
    id,
    result
  } = obj;
  let callback = callbacks[id];
  if (isFn(callback)) {
    callback.length === 1 ? callback(JSON.stringify(result)) : callback(null, result);
  }
}

initPrompt();

export function promptSend(fn, param, callback) {
  let id = __uid++;
  let message = JSON.stringify({
    cmd: fn,
    id,
    params: param
  });
  callbacks[id] = callback;
  theWindow.prompt(message);
};

export function supportPrompt() {
  return isAndroid() && compareAppVersion('>', '4.2.0');
};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/core/old_prompt.js